
import React, { useEffect, useRef, useState } from "react";

import "react-phone-input-2/lib/bootstrap.css";
import "react-phone-input-2/lib/style.css";
import * as Yup from 'yup';
import addressicon from "../../assets/images/address.svg";

import { useFormik } from "formik";
import useCountries from "hooks/useCountries";
import GoogleMapModal from "components/Modals/GoogleMapModal";
import { jobService } from "services/job.service";
import { toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import ChooseCatpopup from "components/Auth/ChooseCatpopup";
import arrowdrop from "../../assets/images/arrow-drop.svg";
import calendarImg from '../../assets/images/calendar.png'
import { useNavigate } from "react-router-dom";
import parse from "html-react-parser";
import { Offcanvas } from "react-bootstrap";


const CreateJob = ({ show, setShow, onHide }) => {
    const [modalShow, setModalShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState(null);
    const [userAddress, setUserAddress] = useState(null);
    const [readOnlyData, setReadOnlyData] = useState([])
    const [location, setLocation] = useState({
        lat: 0,
        lng: 0
    });
    const [currDate, setCurrDate] = useState(new Date())
    const [isDatePickerOpen, setDatePickerOpen] = useState(false);
    const { countries } = useCountries();

    const datePickerRef = useRef(null);
    const navigate = useNavigate();

    const modalCloseHandler = () => {
        setShowModal(false);
    }

    const handleSpeclialisedList = (item) => {
        const updatedValues = formik.values.specialisedId;
        if (updatedValues[item?._id]) {
            delete updatedValues[item?._id]
        } else {
            updatedValues[item?._id] = item?.title
        }
        if (Object.keys(updatedValues).length > 0) setError(null);
        formik.setFieldValue('specialisedId', updatedValues)
    }

    const handleImageClick = () => {
        setDatePickerOpen(true);
    };

    const handleCloseDatePicker = () => {
        setDatePickerOpen(false);
    };
    const formik = useFormik({
        initialValues: {
            title: "",
            address: "",
            // countryId: countries.length > 0 ? countries[0]._id : '',
            // state: "",
            // city: "",
            specialisedId: [],
            areaSize: "",
            areaUnit: "Sq/Ft",
            requiredDate: currDate,
            instructions: "",
            description: "",
            pilotIds: [],
        },
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            title: Yup.string().required("Please enter title"),
            address: Yup.string().required("Please enter address"),
            areaSize: Yup.string().required("Please enter Area Size "),
            areaUnit: Yup.string().optional("Please enter Area Unit "),
            requiredDate: Yup.string().required("Please enter Required Date "),
            // specialisedId: Yup.string().required("Please enter specialized ID "),
            instructions: Yup.string().required("Please Enter instructions ").trim().max(1000, 'Instructions must be at most 1000 characters'),
            description: Yup.string().required("Please enter description").trim().max(1000, 'Description must be at most 1000 characters')
        }),
        onSubmit: async (values) => {
            values.latitude = location.lat;
            values.longitude = location.lng;
            values.countryId = readOnlyData?.country || "";
            values.state = readOnlyData?.state || "";
            values.city = readOnlyData?.city || "";
            const payload = {
                ...values,
                specialisedId: Object.keys(values.specialisedId),
            }

            if (payload.specialisedId.length === 0) {
                setError('Please select category')
                return;
            }
            try {
                setIsLoading(true);
                const response = await jobService.addjob(payload);
                setTimeout(() => {
                    toast.success(response?.data?.message);
                    setIsLoading(false);
                    setShowModal(false);
                    setShow(false);
                    navigate('/my-jobs');
                }, 2000);
                if (response?.data?.success === false) {
                    toast.warning(response?.data?.message);
                }
            } catch (err) {
                toast.warning(err?.response?.data?.message);
            }
        },
    });

    const handleCreateJob = (e) => {
        e.preventDefault();
        formik.setFieldValue('pilotIds', []);
        formik.handleSubmit();
    };

    const handleRequestPilot = async () => {
        const errors = await formik.validateForm();
        if (Object.keys(errors).length === 0) {
            if (Object.keys(formik.values.specialisedId).length === 0) {
                setError('Please select category');
                return;
            }
            const values = { ...formik.values };
            values.latitude = location.lat;
            values.longitude = location.lng;
            values.countryId = readOnlyData?.country || "";
            values.state = readOnlyData?.state || "";
            values.city = readOnlyData?.city || "";
            const payload = {
                ...values,
                specialisedId: Object.keys(values.specialisedId),
            }
            navigate('/pilot-optimization', { state: { jobData: payload } });
            if (setShow) setShow(false);
        } else {
            formik.handleSubmit(); // This will show validation errors
        }
    };

    const getFormattedDate = (date) => {
        if (!date) {
            date = new Date();
        }
        const options = { month: 'short', day: 'numeric', year: 'numeric' };
        return date.toLocaleDateString("en-US", options);
    }

    const handleDateChange = date => {
        formik.setFieldValue('requiredDate', date);
    };


    useEffect(() => {
        formik.setFieldValue("latitude", location.lat);
        formik.setFieldValue("longitude", location.lng);
    }, [location]);

    useEffect(() => {
        formik.setFieldValue("address", userAddress)
    }, [userAddress])

    const formatSpecializations = (data) => {
        let result = "Select Specialized";
        if (Object.values(formik.values.specialisedId)?.length > 0) {
            const namesArr = Object.values(formik.values.specialisedId);
            result = namesArr.slice(0, 4).join();
            if (namesArr.length > 4) {
                result += ` <b>+${namesArr.length - 4}</b>`
            }
        }
        return parse(result);
    }


    return (
        <>

            <form>
                <Offcanvas show={show} onHide={onHide} placement='end' backdrop>
                    <div className="create-job">
                        <Offcanvas.Header closeButton>
                            <h5>Create Job</h5>
                        </Offcanvas.Header>

                        <Offcanvas.Body className="flex-grow-1 overflow-auto">

                            <div className=" mb-30">
                                <label >Job Title</label>
                                <input
                                    type="text"
                                    name="title"
                                    id="title"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.title}
                                    className="form-control rounded-3 bg-cyan w-100"
                                    required
                                />
                                {formik.touched.title && formik.errors.title ? (
                                    <span className="text-danger">{formik.errors.title}</span>
                                ) : null}
                            </div>

                            <div className="mb-30">
                                <label className="py-2">Address</label>
                                <br />

                                <div className="addres-icon rounded-3 bg-cyan w-100 px-3 py-3">
                                    <input
                                        type="text"
                                        placeholder="Enter Address"
                                        className="address-input w-100 bg-transparent border-0"
                                        name="address"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.address}
                                        readOnly
                                    />

                                    <img
                                        onClick={() => setShowModal(true)}
                                        alt='' src={addressicon}
                                        className="cursor-pointer"
                                    />
                                </div>
                                {formik.touched.address && formik.errors.address ? (
                                    <span className="text-danger">{formik.errors.address}</span>
                                ) : null}
                            </div>
                            <div className="mb-30">
                                <label className="py-2">Country</label>
                                <br />
                                <select className={`select-dropdown country ${readOnlyData?.country ? '' : 'text-secondary'}`} name="countryId"
                                    value={readOnlyData?.country}
                                // disabled
                                >
                                    {!readOnlyData?.country && (
                                        <option value="">Country</option>
                                    )}
                                    {countries.length > 0 && countries.map((country) => (
                                        <option key={country._id} value={country._id}>
                                            {country?.CountryName}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="mb-30">
                                <label className="py-2">State</label>
                                <br />

                                <input
                                    type="text"
                                    placeholder="State"
                                    className="form-control rounded-3 bg-cyan w-100"
                                    name="state"
                                    value={readOnlyData?.state || ""}
                                    disabled
                                />
                            </div>
                            <div className="mb-30">
                                <label className="py-2">City</label>
                                <br />

                                <input
                                    type="text"
                                    placeholder="City"
                                    className="form-control rounded-3 bg-cyan w-100"
                                    name="city"
                                    value={readOnlyData?.city || ""}
                                    disabled
                                />
                            </div>
                            <div className="d-flex  ">
                                <div className="mb-30 me-2 w-50">
                                    <label >Area Size </label>
                                    <br />

                                    <input
                                        type=""
                                        id="areaSize"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.areaSize}
                                        className="form-control rounded-3 bg-cyan w-100"
                                    />
                                    {formik.touched.areaSize && formik.errors.areaSize ? (
                                        <span className="text-danger">{formik.errors.areaSize}</span>
                                    ) : null}
                                </div>
                                <div className="mb-30 w-50">
                                    <label >Area Unit </label>
                                    <br />

                                    <select className="rounded-3 area-arrow select-dropdown"
                                        id="areaUnit"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.Unit}>
                                        <option>Sq/Ft</option><option>Acres</option>
                                    </select>
                                    {formik.touched.areaUnit && formik.errors.areaUnit ? (
                                        <span className="text-danger">{formik.errors.areaUnit}</span>
                                    ) : null}
                                </div>
                            </div>

                            <div className="position-relative mb-30">
                                <label >Specialized category </label>
                                <br />
                                <button
                                    type="button"
                                    className="btn m-0 btn-secondary text-left w-100  text-capitalize select-cat"
                                    onClick={() =>
                                        setModalShow(true)}
                                >
                                    {formatSpecializations(formik.values.specialisedId)}
                                </button>

                                <img
                                    alt='' src={arrowdrop}
                                    className="position-absolute job-arrow-right"
                                />
                                <ChooseCatpopup
                                    show={modalShow}
                                    onHide={() => setModalShow(false)}
                                    handleSpeclialisedList={handleSpeclialisedList}
                                    speclialisedIDs={Object.keys(formik.values.specialisedId)}
                                />
                                {error && <span className="text-danger">{error}</span>}
                            </div>

                            <div className="mb-30 position-relative z-50">
                                <label>Required Date</label>
                                <br />
                                <div className="position-relative">
                                    <div className="d-flex justify-content-between form-control rounded-3 bg-cyan w-100">
                                        <DatePicker
                                            selected={formik.values.requiredDate}
                                            onBlur={formik.handleBlur}
                                            className="bg-transparent border-0 caret-transparent"
                                            onChange={(date) => {
                                                handleDateChange(date);
                                                handleCloseDatePicker();
                                            }}
                                            onClickOutside={() => { setDatePickerOpen(false); }}
                                            value={getFormattedDate(formik.values.requiredDate)}
                                            ref={datePickerRef}
                                            open={isDatePickerOpen}
                                            readOnly
                                            minDate={new Date()}
                                        />
                                        <img src={calendarImg} onClick={handleImageClick} className="cursor-pointer date-picker-icon" alt="" />
                                    </div>

                                    {formik.touched.requiredDate && formik.errors.requiredDate ? (
                                        <span className="text-danger">{formik.errors.requiredDate}</span>
                                    ) : null}

                                </div>
                            </div>

                            <div className="mb-30 position-relative z-1">
                                <label >Instructions</label>
                                <br />
                                <textarea
                                    className="form-control"
                                    placeholder=""
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.instructions}
                                    id="instructions"
                                    rows="6"
                                    maxLength={1000}
                                />
                                <label className="d-block text-end pt-1 pe-1">{formik.values.instructions.length}/1000</label>
                                {formik.touched.instructions && formik.errors.instructions ? (
                                    <span className="text-danger">{formik.errors.instructions}</span>
                                ) : null}
                            </div>
                            <div className="mb-30">
                                <label >Add Job Description</label>
                                <br />
                                <textarea
                                    className="form-control"
                                    placeholder=""
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.description}
                                    id="description"
                                    rows="6"
                                    maxLength={1000}
                                />
                                <label className="d-block text-end pt-1 pe-1">{formik.values.description.length}/1000</label>
                                {formik.touched.description && formik.errors.description ? (
                                    <span className="text-danger">{formik.errors.description}</span>
                                ) : null}
                            </div>

                        </Offcanvas.Body>
                        <div className="d-flex gap-2 p-3 create-job-footer">
                            <button
                                type="button"
                                className="btn btn-secondary w-50"
                                onClick={handleCreateJob}
                                disabled={isLoading}
                            >
                                {isLoading ? "Loading..." : "Request Bid"}
                                <span className="d-block" style={{ fontSize: "10px" }}>(all pilots)</span>
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary w-50"
                                onClick={handleRequestPilot}
                                disabled={isLoading}
                            >
                                {isLoading ? "Loading..." : "Select a Pilot"}
                                <span className="d-block" style={{ fontSize: "10px" }}>(to bid)</span>
                            </button>
                        </div>
                    </div>
                </Offcanvas>
            </form >
            <GoogleMapModal
                show={showModal}
                closeHandler={modalCloseHandler}
                setUserAddress={setUserAddress}
                location={location}
                setLocation={setLocation}
                setReadOnlyData={setReadOnlyData}
                countries={countries}
                userAddress={userAddress}
            />
        </>
    );
}
export default CreateJob;
